import React from "react";
import { EmptyLayoutComponent } from "../_shared/emptyLayout/EmptyLayoutComponent";

export const UmSpStartUpScreenComponent = () => (
    <EmptyLayoutComponent message="initializing..." />
);
